import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Formik, Form } from 'formik'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaCheckDouble, FaEdit, FaPlusCircle, FaUser } from 'react-icons/fa'
import toast from 'react-hot-toast'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import SwitchButtons from '../../../shared/SwitchButtons'
import DropdownField from '../../../shared/DropdownField'
import AutoCompleteField from '../../../shared/AutoCompleteField'
import TextInput from '../../../shared/TextInput'
import {
  actPriorityOptions,
  cardLabels,
  getCardOptions,
  patientCashPlansOptionsFormat,
  patientDocIdFieldsOptionsFormat,
  patientFileNoFieldsOptionsFormat,
  patientInsuracnePlansOptionsFormat,
  patientMobileFieldsOptionsFormat,
  patientsNameFieldOptionsFormat,
  paymentMethods,
  practionerOptionsFormat,
  visitTypeOptions,
  getCardCost,
  getFixedCardCost,
} from '../../../constants/VisitsConstants'
import { createVisitValidationSchema } from '../../../validations/VisitsValidations'
import VisitPriceItems from './VisitPriceItems'
import CustomButton from '../../../shared/CustomButton'
import {
  createNewVisit,
  getCashPayersData
} from '../../../redux/slices/VisitsSlice'
import {
  getPractitionerList,
  getPriceListByPractitionerId,
  handleCheckPatientElibility
} from '../../../services/ApiMethods'
import CheckPermission from '../../../hooks/CheckPermission'
import {
  calculateCashItemsDetails,
  calculateInsuranceItemsDetails
} from './VisitItemsCalculations'
import { useTranslation } from 'react-i18next'
import { IoTimeOutline } from 'react-icons/io5'
import { MultiSelect } from 'primereact/multiselect'
import MultiSelectField from '../../../shared/MultiSelectField'
import { fetchData } from '../../../helpers/fetchData'
import SwitchInput from '../../../shared/SwitchInput'
import Spinner from '../../../shared/Spinner'
import { beneficiaryTableColumnsData } from '../../../constants/BeneficiaryConstants'
import BeneficiaryPersonalDataForm from '../benificiary/BeneficiaryPersonalDataForm'
import { BiSolidEditAlt } from 'react-icons/bi'
import { RiEditCircleFill } from 'react-icons/ri'
import { priorityOptions } from '../../../constants/QueueManagementConstants'
import ReusableModal from '../../../shared/ReuseableModal'
import PatientListModal from './PatientListModal'
import BillSummaryOld from './BillSummaryOld'

const EditClaimForm = ({
  visit_category,
  selectedPatient,
  openDepositForm,
  editData
}) => {
  const { t, i18n } = useTranslation()
  const formRef = useRef(null)
  const { state } = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [openListModal, setOpenListModal] = useState(false)
  const [listModalData, setListModalData] = useState([])
  const { hasPermission } = CheckPermission()
  const [followUp, setFollowUp] = useState(null)
  const { cashPayers } = useSelector(state => state?.visits)
  const preSelectedPatientData = state?.patientDetails || null
  const isCreatedFromAppointment = state?.isCreatedFromAppointment || false
  const {
    day = '',
    start_time = '',
    date = '',
    selectedPractitionerId = '',
    appointment_id = '',
    end_time = ''
  } = state ?? {}
  const [patientType, setPatientType] = useState('cash')
  const [selectedPatientData, setSelectedPatientData] = useState(null)
  const [payemntStatus, setPaymentStatus] = useState(
    editData?.payment_status?.toLowerCase() || state?.payment_status || 'paid'
  )
  const [depositLoading, setDepositLoading] = useState(false)
  const [depositBalance, setDepositBalance] = useState(0)
  const [cardOptions, setCardOptions] = useState([])
  const [patientInsuracnePlans, setPatientInsurancePlans] = useState([])
  const [eligibilityChecked, setEligibilityChecked] = useState(false)
  const [practitionersList, setPractionersList] = useState([])
  const [selectedPayerData, setSelectedPayerData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [searchLoading, setSearchLoading] = useState(false)
  const [fieldsLoading, setFieldsLoading] = useState(false)
  const [eligibilityLoading, setEligibilityLoading] = useState(false)
  const isHasPractitionerPermission = hasPermission('practitioner', 'get')
  const isHaveGetPayerPermission = hasPermission('payer', 'get')
  const [episodeType, setEpisodeType] = useState('')
  const [episodeId, setEpisodeId] = useState('')
  const isHaveGetPricelistPermission = hasPermission('pricelists', 'get')
  const [speciality, setSpeciality] = useState(
    editData?.practitioner?.speciality?.name_en || ''
  )
  const [department, setDepartment] = useState('')
  const [practitionerData, setPractitionerData] = useState(null)
  const [contactPagination, setContactPagination] = useState({
    page: 1,
    perPage: 10
  })

  const initialValues = {
    isCreatedFromAppointment: isCreatedFromAppointment ? true : false,
    start_time: editData?.start_time || start_time,
    end_time: end_time,
    appointment_id: appointment_id || '',
    visit_date: moment(date, 'YYYY-MM-DD').toDate(),
    patientName:
      editData?.patient?.full_name || preSelectedPatientData?.full_name || '',
    patientDocumentId:
      editData?.patient?.document_id ||
      preSelectedPatientData?.document_id ||
      state?.doc_id ||
      selectedPatient?.document_id ||
      '',
    patientFileNo:
      editData?.patient?.file_no ||
      preSelectedPatientData?.file_no ||
      selectedPatient?.file_no ||
      '',
    patientType:
      editData?.patient?.beneficiary_type?.toLowerCase() ||
      preSelectedPatientData?.beneficiary_type?.toLowerCase() ||
      'cash',
    practitioner: editData?.practitioner_id || selectedPractitionerId || '',
    payerName: getSelectedPayerData() || '',
    speciality: editData?.practitioner?.speciality?.name_en || '',
    visitType: editData?.visit_type?.type || 'Consultation',
    priority: editData?.priority?.coding?.[0]?.code || 'el',
    paymentMethod: editData?.payment_method || 'card',
    comment: editData?.comment || '',
    contactNo:
      editData?.patient?.contact || preSelectedPatientData?.contact || '',
    items: editData?.items || [],
    paid: payemntStatus,
    cardType:
      editData?.payment_method == 'card'
        ? editData?.payment_detail?.[0]?.payment_method
        : 'Mada'
  }

  useEffect(() => {
    if (practitionerData) {
      getCardOptions(setCardOptions, practitionerData)
    }
  }, [practitionerData])
  useEffect(() => {
    handleSetFieldValue('paid', payemntStatus)
  }, [payemntStatus])

  const handleSetFieldValue = (field, value) => {
    const currentValues = formRef?.current?.values || {}
    formRef?.current?.setValues({
      ...currentValues,
      [field]: value
    })
  }

  useEffect(() => {
    if (isHasPractitionerPermission) {
      getPractitionerList(setFieldsLoading, setPractionersList)
    }
  }, [isHasPractitionerPermission])

  useEffect(() => {
    if (isHaveGetPayerPermission && !cashPayers) {
      dispatch(getCashPayersData())
    }
  }, [isHaveGetPayerPermission])

  const handleChangeVisitType = (event, props) => {
    let value = event?.target?.value
    setFollowUp(value)
    props.setFieldValue('visitType', value)

    props.setFieldValue('items', [])
  }

  const handleFormSubmit = async values => {
    if (!hasPermission('cliamgeneration', 'update')) return;
    const currentTime = moment().format('HH:mm')
    const formattedVisitDate = `${moment(values?.visit_date).format(
      'YYYY-MM-DD'
    )}T${currentTime}`
    const prioritySelected = actPriorityOptions(t).find(
      option => option.value === values?.priority
    )
    const cardCostValue = getFixedCardCost(cardOptions, values?.cardType);

    const itemsDetails = values?.patientType == 'cash'
      ? calculateCashItemsDetails({ ...values, document_type: selectedPatientData?.document_type }, cardCostValue)
      : calculateInsuranceItemsDetails(
        values,
        selectedPayerData?.max_limit,
        selectedPatientData,
        cardCostValue
      );

    const netCashPay = Number(
      (itemsDetails?.totals?.netPayableAmount || 0) +
      (itemsDetails?.totals?.patientTaxTotal || 0)
    )

    const netInsurancePay = Number(
      (itemsDetails?.totals?.patientShareTotal || 0) +
      (itemsDetails?.totals?.patientTaxTotal || 0)
    )

    const totalAmount = (values?.patientType !== 'cash' ? netInsurancePay : netCashPay).toFixed(2)

    if (values?.paymentMethod === 'multi_payment') {
      const inputCash = Number(values?.cash || 0)
      const inputBank = Number(values?.bank || 0)
      const inputCards = values.cards?.reduce((sum, card) => sum + (Number(card.amount) || 0), 0) || Number(values?.[values?.cardType] || 0);

      const totalInput = inputCash + inputBank + inputCards

      if (Math.abs(totalAmount - totalInput) > 0.05) {
        toast.error(
          `Total payment (${totalInput?.toFixed(
            2
          )}) must match the bill amount (${totalAmount})`
        )
        return
      }
    }

    const payload = {
      ...editData,
      priority: {
        coding: [
          {
            system: 'http://terminology.hl7.org/CodeSystem/encounter-priority',
            code: prioritySelected?.value,
            display: prioritySelected?.label
          }
        ],
        text: prioritySelected?.text
      },
      visit_payment_type: values?.patientType,
      appointment_id: values?.appointment_id,
      visit_type: { type: values?.visitType },
      contactNo: values?.contactNo,
      patient_id: selectedPatientData?.patient_id,
      speciality: speciality || values?.speciality,
      department,
      ...(episodeId && { episode_id: episodeId }),
      ...(episodeType && { episode_type: episodeType }),
      practitioner_id: selectedPractitionerId,
      patient: {
        ...editData?.patient,
        full_name: values?.patientName,
        document_id: values?.patientDocumentId,
        file_no: values?.patientFileNo,
        contact: values?.contactNo
      },
      payment_method: values?.paymentMethod,
      ...(values?.paymentMethod == 'multi_payment' && {
        payment_detail: [
          {
            payment_method: 'cash',
            amount: values?.cash
          },
          {
            payment_method: 'bank',
            amount: values?.bank
          },
          {
            payment_method: values?.cardType,
            amount: values?.[values?.cardType],
            card_cost: getCardCost(cardOptions, values?.cardType, itemsDetails?.totals?.patientShareTotal)
          }
        ]
      }),
      ...(values?.paymentMethod == 'card' && {
        payment_detail: [
          {
            payment_method: values?.cardType,
            amount: totalAmount,
            card_cost: getCardCost(cardOptions, values?.cardType, itemsDetails?.totals?.patientShareTotal)
          }
        ]
      }),
      payment_status: values?.paid == 'paid' ? 'Paid' : 'UnPaid',
      visit_category: editData?.visit_category || visit_category,
      comment: values?.comment,
      items: values?.items.map(
        ({ low_stock, out_of_stock, is_stock, stock, ...item }) => ({
          ...item,
          discount_amount: Number(item?.discount_amount),
          quantity: Number(item?.quantity),
          unit_price: Number(item?.unit_price),
          patientShareAmount: Number(item?.patient_share),
          patient_share: String(item?.patient_share),
          status: values?.paid == 'paid' ? 'Paid' : 'UnPaid',
          ...(item?.item_category === 'insurance' && {
            approved_qty: Number(item?.approved_qty) || 0,
            approved_amount: Number(item?.approved_amount) || 0
          })
        })
      )
    }

    const commonInvoicePayload = {
      date: formattedVisitDate,
      paid: values?.paid == 'paid' ? true : false,
      invoice_ref: 0,
      description: values?.comment,
      item_details: itemsDetails,
      customer_id: selectedPatientData?.patient_id,
      payment_method: values?.paymentMethod,
      ...(values?.paymentMethod == 'multi_payment' && {
        payment_detail: [
          {
            payment_method: 'cash',
            amount: values?.cash
          },
          {
            payment_method: 'bank',
            amount: values?.bank
          },
          {
            payment_method: values?.cardType,
            amount: values?.[values?.cardType],
            card_cost: getCardCost(cardOptions, values?.cardType, itemsDetails?.totals?.patientShareTotal)
          }
        ]
      }),
      ...(values?.paymentMethod == 'card' && {
        payment_detail: [
          {
            payment_method: values?.cardType,
            amount: totalAmount,
            card_cost: getCardCost(cardOptions, values?.cardType, itemsDetails?.totals?.patientShareTotal)
          }
        ]
      }),
      tax_type: 'percentage',
      tax_amount: 15
    }

    const invoicePayload =
      values?.patientType === 'cash'
        ? {
          ...commonInvoicePayload,
          invoice_type: 'sales',
          payer_id: selectedPayerData?.payer_id
        }
        : {
          ...commonInvoicePayload,
          invoice_type: 'credit',
          payer_id: selectedPayerData?.his_payer_id
        }

    if (values?.paid == 'paid') {
      payload.invoice_details = invoicePayload
    }
    console.log('====================================')
    console.log(payload)
    console.log('====================================')
  }

  useEffect(() => {
    if (preSelectedPatientData) {
      setPatientType(preSelectedPatientData?.beneficiary_type?.toLowerCase())
      if (preSelectedPatientData?.beneficiary_type?.toLowerCase() != 'cash') {
        setPatientInsurancePlans([
          ...(preSelectedPatientData?.Plan || [])
          // ...(cashPayers?.length ? [cashPayers[0]] : []),
        ])
        setSelectedPayerData(preSelectedPatientData?.Plan?.[0])
      } else {
        setSelectedPayerData(cashPayers?.[0])
      }

      setSelectedPatientData(preSelectedPatientData)
    }
  }, [preSelectedPatientData])

  function getSelectedPayerData() {
    if (preSelectedPatientData?.beneficiary_type?.toLowerCase() != 'cash') {
      return preSelectedPatientData?.Plan?.[0]?.his_payer_id
    } else if (
      preSelectedPatientData?.beneficiary_type?.toLowerCase() == 'cash'
    ) {
      return cashPayers?.[0]?.payer_id
    }
  }

  useEffect(() => {
    if (practitionersList?.length) {
      const practitioner = practitionersList?.find(
        data => data?.practitioner_id == selectedPractitionerId
      )
      formRef?.current?.setFieldValue(
        'speciality',
        practitioner?.speciality?.name_en
      )
      setSpeciality(practitioner?.speciality)
      setDepartment(practitioner?.department)
      setPractitionerData(practitioner)
    }
  }, [practitionersList])

  return (
    <div className='w-full h-full'>
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={handleFormSubmit}
      >
        {props => (
          <div className='w-full grid grid-cols-12 gap-x-3 gap-y-1 mt-2'>
            <Form className='w-full col-span-12'>
              <div className='grid grid-cols-12 gap-5 mb-2'>
                <div className='col-span-12 md:col-span-8 xl:col-span-9'>
                  <div className='flex items-end flex-col-reverse w-full justify-end'>
                    <div className='grid grid-cols-12 gap-x-3 mb-2 w-full'>
                      <div className='col-span-12 md:col-span-12 lg:col-span-6 xl:col-span-4'>
                        <label className='input-label block'>
                          {t('PatientType')}
                        </label>
                        <SwitchButtons
                          labels={[
                            { name: t('Cash'), value: 'cash' },
                            { name: t('Insurance'), value: 'insurance' },
                            { name: t('Corporate'), value: 'corporate' },
                            { name: t('Government'), value: 'government' }
                          ]}
                          setActiveState={setPatientType}
                          activeState={patientType}
                        />
                      </div>
                      <div className='col-span-12 md:col-span-12 lg:col-span-3 xl:col-span-4 !gap-0'>
                        <label className='input-label block'>
                          {t('PaymentStatus')}
                        </label>
                        <SwitchButtons
                          label1={{ name: t('Paid'), value: 'paid' }}
                          label2={{ name: t('Unpaid'), value: 'unpaid' }}
                          setActiveState={setPaymentStatus}
                          activeState={payemntStatus}
                        />
                      </div>

                      <DropdownField
                        parentClass='col-span-12 md:col-span-12 lg:col-span-3 xl:col-span-4 !gap-0'
                        label={t('Act Priority')}
                        name='priority'
                        options={actPriorityOptions(t)}
                        placeholder={t('SelectPriority')}
                      />
                    </div>
                  </div>
                  <div className='w-full grid grid-cols-12 gap-3 '>
                    <TextInput
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('SelectPatient')}
                      placeholder={t('Search By Patient Name')}
                      name='patientName'
                    />
                    <TextInput
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('MRN')}
                      placeholder={t('SearchPatientByMRN')}
                      name='patientFileNo'
                    />
                    <TextInput
                      value={props?.values?.patientDocumentId}
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('DocumentId')}
                      placeholder={t('Search By Doc ID')}
                      name='patientDocumentId'
                    />
                    <TextInput
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('PatientMobile')}
                      placeholder={`${t('SearchPatientByMobile')} No`}
                      name='contactNo'
                    />
                    {console.log(props?.errors)}
                    <DropdownField
                      key={props.values.payerName || 'empty'}
                      value={props?.values?.payerName}
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('SelectPayer')}
                      placeholder={t('SelectPayer')}
                      name='payerName'
                      optionLabel='label'
                      optionValue='value'
                      options={
                        props.values.patientType == 'cash'
                          ? patientCashPlansOptionsFormat(cashPayers)
                          : patientInsuracnePlansOptionsFormat(
                            patientInsuracnePlans
                          )
                      }
                      onChange={event => {
                        let value = event?.target?.value
                        if (props?.values?.patientType == 'cash') {
                          let payerData = cashPayers?.find(
                            data => data?.payer_id == value
                          )
                          props.setFieldValue('payerName', value)
                          props.setFieldValue('items', [])
                          setSelectedPayerData(payerData)
                        } else {
                          let payerData = patientInsuracnePlans?.find(
                            data =>
                              data?.his_payer_id == value ||
                              data?.payer_id == value
                          )
                          props.setFieldValue('payerName', value)
                          props.setFieldValue('items', [])
                          setSelectedPayerData(payerData)
                        }
                      }}
                    />
                    <DropdownField
                      loading={fieldsLoading}
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('SelectPractitioner')}
                      placeholder={t('SelectPractitioner')}
                      name='practitioner'
                      filter
                      options={practionerOptionsFormat(practitionersList)}
                    // onChange={event => handleChangePractitioner(event, props)}
                    />
                    <TextInput
                      value={speciality?.name_en || speciality}
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('Speciality')}
                      placeholder={t('Speciality')}
                      onChange={event => setSpeciality(event.target.value)}
                      name='speciality'
                      onBlur={event => {
                        if (!event.target.value && practitionerData) {
                          formRef?.current?.setFieldValue(
                            'speciality',
                            practitionerData?.speciality?.name_en
                          )
                          setSpeciality(practitionerData?.speciality)
                        }
                      }}
                    />
                    <DropdownField
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('VisitType')}
                      placeholder={t('SelectVisitType')}
                      name='visitType'
                      options={[
                        ...visitTypeOptions(t),
                        { label: t('Corporate'), value: 'corporate' },
                        { label: t('Government'), value: 'government' }
                      ]}
                      onChange={event => handleChangeVisitType(event, props)}
                    />
                    <DropdownField
                      parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                      label={t('PaymentMethod')}
                      placeholder={t('SelectPaymentMethod')}
                      name='paymentMethod'
                      options={[
                        ...paymentMethods(t),
                        ...[
                          {
                            label: 'Deposit',
                            value: 'Deposit'
                          }
                        ]
                      ]}
                      onChange={e => {
                        const method = e.value
                        const currentCardKey = props.values.cardType || 'Mada'

                        props.setFieldValue('paymentMethod', method)
                        if (method === 'card') {
                          props.setValues(prev => ({
                            ...prev,
                            paymentMethod: method,
                            cardType: currentCardKey,
                            cash: null,
                            bank: null
                          }))
                        } else if (method === 'multi_payment') {
                          props.setValues(prev => ({
                            ...prev,
                            paymentMethod: method,
                            cardType: prev.cardType || 'Mada',
                            cash: prev.cash ?? 0,
                            bank: prev.bank ?? 0,
                            [currentCardKey]: prev[currentCardKey] ?? 0
                          }))
                        } else {
                          props.setValues(prev => ({
                            ...prev,
                            paymentMethod: method,
                            cardType: '',
                            cash: null,
                            bank: null,
                            [currentCardKey]: null
                          }))
                        }
                      }}
                    />
                    {(props?.values?.paymentMethod === 'card' ||
                      props?.values?.paymentMethod === 'multi_payment') && (
                        <DropdownField
                          parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                          label={t('Card Type')}
                          placeholder={t('SelectCardType')}
                          name='cardType'
                          options={cardOptions}
                        />
                      )}
                    {props?.values?.paymentMethod === 'multi_payment' && (
                      <>
                        <TextInput
                          parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                          name='cash'
                          label={t('Cash')}
                          placeholder={t('EnterCashAmount')}
                          type='number'
                          step='any'
                        />
                        <TextInput
                          parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                          name='bank'
                          label={t('Bank')}
                          placeholder={t('EnterBankAmount')}
                          type='number'
                          step='any'
                        />
                        <TextInput
                          parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'
                          name={props?.values?.cardType || 'Mada'}
                          label={cardLabels[props?.values?.cardType] || 'Mada'}
                          placeholder={t('EnterAmount')}
                          type='number'
                          step='any'
                        />
                      </>
                    )}
                    {depositBalance > 0 && (
                      <SwitchInput
                        name='deduct_from_deposit'
                        value={props?.values?.deduct_from_deposit}
                        label={t('Deduct From Deposit')}
                        handleChange={e => {
                          props.setFieldValue('deduct_from_deposit', e.value)
                          if (e.value) {
                            const cashDetails = calculateCashItemsDetails(
                              props?.values
                            )

                            const insuranceDetails =
                              calculateInsuranceItemsDetails(
                                props?.values,
                                selectedPayerData?.max_limit,
                                selectedPatientData
                              )

                            let netCashPay = Number(
                              (cashDetails?.totals?.netPayableAmount || 0) +
                              (cashDetails?.totals?.patientTaxTotal || 0)
                            )

                            let netInsurancePay = Number(
                              (insuranceDetails?.totals?.patientShareTotal ||
                                0) +
                              (insuranceDetails?.totals?.patientTaxTotal || 0)
                            )

                            const totalNetPay =
                              patientType != 'cash'
                                ? netInsurancePay
                                : netCashPay

                            if (depositBalance >= totalNetPay) {
                              props.setFieldValue('paymentMethod', 'Deposit')
                            }
                          } else {
                            props.setFieldValue('paymentMethod', 'card')
                          }
                        }}
                        parentClass='col-span-12 md:col-span-6 justify-between lg:col-span-4 xl:col-span-2'
                      />
                    )}

                    <TextInput
                      className='h-40'
                      parentClass='col-span-12'
                      label={t('Comment')}
                      placeholder={t('AddComment')}
                      name='comment'
                    />
                    <div className='col-span-12'>
                      <div
                        className={`flex items-center border cursor-pointer border-gray-200 rounded-md py-2 !bg-gradient w-fit px-4`}
                      >
                        <IoTimeOutline
                          size={17}
                          className={`me-2 !text-white`}
                        />
                        <p className={`!text-white`}>
                          {props?.values?.start_time} -{' '}
                          {props?.values?.end_time}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <BillSummaryOld
                  patientType={patientType}
                  formikRef={formRef}
                  selectedPatientData={selectedPatientData}
                  selectedPayerData={selectedPayerData}
                  cardOptions={cardOptions}
                />
              </div>
              {/* {props.values?.visitType !== "Follow up" && */}
              {isHaveGetPricelistPermission && (
                <div className='mt-2'>
                  <VisitPriceItems
                    formikRef={formRef}
                    formValues={formRef?.current?.values}
                    selectedPayerData={selectedPayerData}
                    department_id={department?.id || practitionerData?.department?.id}
                    selectedPatientData={{
                      ...selectedPatientData,
                      patientType
                    }}
                  />
                </div>
              )}
              {/* )} */}
              <div className='flex items-center justify-end mt-3 gap-3'>
                {hasPermission('cliamgeneration', 'update') && (
                  <CustomButton
                    type='submit'
                    label={t('Edit Claim')}
                    loading={isLoading}
                    icon={<FaCheckDouble size={12} className='me-2' />}
                    buttonType='primary'
                  />
                )}
              </div>
            </Form>
          </div>
        )}
      </Formik>
    </div>
  )
}

export default EditClaimForm
